<template>
	<div class="centre">
		<div class="title">
			<div>资料设置</div>
		</div>
		<div class="form">
		
			
			<div class="div1">
				<label>用户名:</label>
				<input type="text" placeholder="请输入用户名" v-model="data['username']" />
				<div class="div"></div>
			</div>
			<div class="div1">
				<label>国籍:</label>
				<input type="text" placeholder="请输入国籍" v-model="data['nationality']" />
				<div class="div"></div>
			</div>
			<div class="div1">
				<label>城市:</label>
				<input type="text" placeholder="请输入城市" v-model="data['city']" />
				<div class="div"></div>
			</div>
			<div class="div1">
				<label>手机号码:</label>
				<input type="text" placeholder="请输入手机号码" v-model="data['mobile']" />
				<div class="div">
					<div @click="upd('mobile')">修改</div>
				</div>
			</div>
			<div class="div1">
				<label>邮箱:</label>
				<input type="text" placeholder="请输入邮箱" v-model="data['email']" />
				<div class="div">
					<div  @click="upd('email')">修改</div>
				</div>
			</div>
			<div class="div1">
				<label>微信服务号:</label>
				<input type="text" placeholder="绑定微信服务号" v-model="data['wxmark']" />
				<div class="div">
					<div  @click="upd('wxmark')">修改</div>
				</div>
			</div>
			<div class="div1">
				<label>昵称:</label>
				<input type="text" placeholder="请输入昵称" v-model="data['nickname']" />
				<div class="div">
					<div @click="upd('nickname')">修改</div>
				</div>
			</div>
			<div class="div1">
				<label>个人介绍:</label>
				<textarea rows="4" v-model="data['label']"></textarea>
				<div class="div"></div>
			</div>
			<div style="height: 2rem;"></div>
			<div class="div1">
				<label></label>
				 <el-button size="medium" @click="buttonClick()">提交</el-button>
				 <div class="div"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	    data() {
			return {
				data : [],
				
			}
		},
		created() {
			let that  = this;
			that.info();
			
		},
		methods:{
			buttonClick(){
				let that  = this;
			
				that.httpupd(that.data);
			},
			upd(e){
				let that  = this;
				
				if(e=='email'){
					that.$prompt('请输入邮箱', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
					  inputErrorMessage: '邮箱格式不正确'
					}).then(({ value }) => {
						that.httpupd({'email':value});
						that.info();
					});
				}else if(e=='mobile'){
					that.$prompt('请输入手机号码', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  inputPattern: /^1[3456789]d{9}$/,
					  inputErrorMessage: '手机号码格式不正确'
					}).then(({ value }) => {
					  that.httpupd({'mobile':value});
					  that.info();
					});
				}else if(e=='wxmark'){
					that.$prompt('请输入微信服务号', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					 
					}).then(({ value }) => {
					  that.httpupd({'wxmark':value});
					  that.info();
					});
				}else if(e=='nickname'){
					that.$prompt('请输入昵称', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					 
					}).then(({ value }) => {
					  that.httpupd({'wxmark':value});
					  that.info();
					});
				}
				
			},
			httpupd(data){
				let that = this;
				that.$http('post','/api/v1/user/upduser',{'data':data}) .then(function (res) {
					if(res.code==200){
						
						that.$message({ showClose: true,message: res.msg,type: 'success'});
					}else{
						that.$message({ showClose: true,message: res.msg,type: 'error'});
					}
				});
			},
			info(){
				let that = this;
				that.$http('get','/api/v1/user/user_info') .then(function (res) {
					that.data  = res.data;
					console.log(that.data);
				});
			}
		}
	}
</script>

<style lang="less">
	.centre {
		width: 100%;
		color: #7F7F7F;
		.title {
			width: 100%;
			border-bottom:1px solid #a29e9eb5;
			line-height: 2rem;
			height: 2rem;
			div {
				padding-left: 0.2rem;
				width: 4rem;
				border-bottom:2px solid #d63030;
			}
		}
		.form {
			width: 80%;
			padding-top: 2rem;
			padding-left: 2rem;
			
			.div1 {
				display: flex;
				margin: 0.5rem;
				label {
					flex: 1;
					line-height: 2rem;
				}
				input,textarea {
					flex: 2;
					border: 1px solid #a29e9eb5;
					
				}
				input {
					height: 2rem;
				}
				textarea{
					resize: none;
						border: 1px solid #a29e9eb5;
				}
				.div {
					flex: 3;
					padding-left: 2rem;
					text-align: center;
					div {
						border: 1px solid #a29e9eb5;
						width: 2.4rem;
						position: relative;
						top: 0.6rem;
						
					}
				}
			}
		}
		
		
	}	
</style>
